<template>
  <custom-dialog width="520px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="form" label-position="top">
        <el-form-item :label="$t('ao_pwd1_mi_ma')" prop="rfid">
          <el-input :maxlength="6" placeholder="" v-model="form.rfid"></el-input>
        </el-form-item>
        <el-form-item :label="$t('ao_pwd1_shi_yong_ren')" prop="cardOwner">
          <el-input placeholder="" v-model="form.cardOwner"></el-input>
        </el-form-item>
        <el-form-item :label="$t('ao_pwd1_lian_xi_dian_hua')" prop="cardOwnerPhone">
          <el-input placeholder="" v-model="form.cardOwnerPhone"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button size="small" type="warning" @click="confirm">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';

// ao_pwd1_mi_ma: 密码：// ao_pwd1_shi_yong_ren: 使用人：// ao_pwd1_lian_xi_dian_hua: 联系电话：// ao_pwd1_cdwgzf: 长度为6个字符// ao_pwd1_mmbxwsz: 密码必须为数字// ao_pwd1_mmyczqcxsr: 密码已存在，请重新输入

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        cardOwner: '',
        cardOwnerPhone: '',
        rfid: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        rfid: [{ required: true, min: 6, max: 6, message: this.$t('ao_pwd1_cdwgzf'), trigger: 'blur' }],
      };
    },
  },
  methods: {
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const numReg = /^\d{1,}$/;
        if (!numReg.test(this.form.rfid)) {
          this.$message.error(this.$t('ao_pwd1_mmbxwsz'));
          return;
        }
        const list = this.model.row || [];
        const has = list.findIndex(t => t.rfid === this.form.rfid);
        if (has !== -1) {
          this.$message.error(this.$t('ao_pwd1_mmyczqcxsr'));
          return;
        }
        this.$emit('success', [this.form]);
      });
    },
  },
};
</script>

<style lang="scss"></style>
